import {
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Icon,
  IconButton,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core'
import { IdentificationInput } from 'components'
import { useValues } from 'hooks'
import { createUserService, EDIT_PATH, editUserService, FIELDS } from 'lib'
import React from 'react'
import { useHistory, useLocation } from 'react-router'
import { IUser } from 'types'

interface Props {
  onSuccess: () => void
  onError: () => void
  onClose: () => void
}

const UserForm = (props: Props) => {
  const { onError, onSuccess, onClose } = props

  const history = useHistory()
  const location = useLocation()
  const { values: user, updateValue: handleChange, updateValues } = useValues()

  const [loading, setLoading] = React.useState<boolean>(false)

  const initialInput = React.useRef<any>(null)

  const handleSumbit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      setLoading(true)
      if (!(location.state as any)?.edit) {
        await createUserService({ ...user, active: true })
      } else {
        const edited = { ...user }
        delete edited[FIELDS.userId.key]
        await editUserService(user[FIELDS.userId.key], { ...edited })
      }
      setLoading(false)
      if (!(location.state as any)?.edit) {
        updateValues({
          name: '',
          email: '',
          password: '',
          identification: '',
          validUntil: new Date(),
          active: true,
        } as IUser)
        initialInput.current?.focus()
      }
      onSuccess()
    } catch (error) {
      setLoading(false)
      onError()
    }
  }

  React.useEffect(() => {
    if ((location.state as any)?.edit) {
      if ((location.state as any)?.values) {
        updateValues((location.state as any)?.values)
      }
    } else {
      history.replace(location.pathname.replace(EDIT_PATH, ''))
    }
  }, [location.state, updateValues, history, location.pathname])

  return (
    <div className="p-4">
      <div className="flex items-center justify-between">
        <Typography variant="body2" style={{ fontWeight: 600, letterSpacing: 0.5 }}>
          {(location.state as any)?.edit ? 'Editar Usuario' : 'Nuevo Usuario'}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Icon fontSize="small">close</Icon>
        </IconButton>
      </div>
      <form onSubmit={handleSumbit} className="pt-4 flex flex-col" style={{ width: 300 }}>
        <TextField
          inputRef={initialInput}
          autoFocus
          size="small"
          label={FIELDS.name.name}
          variant="outlined"
          fullWidth
          required
          value={user[FIELDS.name.key]}
          onChange={(e) => handleChange(FIELDS.name.key, e.target.value)}
        />
        <TextField
          size="small"
          label={FIELDS.email.name}
          variant="outlined"
          fullWidth
          style={{ marginTop: 10 }}
          required
          value={user[FIELDS.email.key]}
          onChange={(e) => handleChange(FIELDS.email.key, e.target.value)}
        />
        {!(location.state as any)?.edit && (
          <TextField
            size="small"
            label={FIELDS.password.name}
            variant="outlined"
            type="password"
            fullWidth
            style={{ marginTop: 10 }}
            required
            value={user[FIELDS.password.key]}
            onChange={(e) => handleChange(FIELDS.password.key, e.target.value)}
          />
        )}
        <TextField
          size="small"
          label={FIELDS.identification.name}
          InputProps={{
            inputComponent: IdentificationInput as any,
          }}
          variant="outlined"
          fullWidth
          style={{ marginTop: 10 }}
          value={user[FIELDS.identification.key]}
          onChange={(e) => handleChange(FIELDS.identification.key, e.target.value)}
        />
        {(location.state as any)?.edit && (
          <FormGroup className="p-2" row>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  size="small"
                  checked={Boolean(user[FIELDS.active.key])}
                  onChange={(e) => handleChange(FIELDS.active.key, e.target.checked)}
                  name={FIELDS.active.name}
                />
              }
              label={FIELDS.activeAlt.name}
            />
          </FormGroup>
        )}

        {/* <Typography
          className={`${(location.state as any)?.edit ? 'pb-2' : 'py-2'} pl-1`}
          variant="caption"
          color="textSecondary"
        >
          {FIELDS.documentActions.name}
        </Typography>
        <FormGroup className="p-2">
          <FormControlLabel
            control={
              <Switch
                color="primary"
                size="small"
                checked={Boolean(user[FIELDS.canApprove.key])}
                onChange={(e) => handleChange(FIELDS.canApprove.key, e.target.checked)}
                name={FIELDS.canApprove.name}
              />
            }
            label={FIELDS.canApprove.name}
          />
          <FormControlLabel
            control={
              <Switch
                color="primary"
                size="small"
                checked={Boolean(user[FIELDS.canReject.key])}
                onChange={(e) => handleChange(FIELDS.canReject.key, e.target.checked)}
                name={FIELDS.canReject.name}
              />
            }
            label={FIELDS.canReject.name}
          />
          <FormControlLabel
            control={
              <Switch
                color="primary"
                size="small"
                checked={Boolean(user[FIELDS.canApproveRefunds.key])}
                onChange={(e) => handleChange(FIELDS.canApproveRefunds.key, e.target.checked)}
                name={FIELDS.canApproveRefunds.name}
              />
            }
            label={FIELDS.canApproveRefunds.name}
          />
        </FormGroup> */}

        {/* <Typography
          className={`${(location.state as any)?.edit ? 'pb-2' : 'py-2'} pl-1`}
          variant="caption"
          color="textSecondary"
        >
          {FIELDS.rejectedActions.name}
        </Typography>
        <FormGroup className="p-2">
          <FormControlLabel
            control={
              <Switch
                color="primary"
                size="small"
                checked={Boolean(user[FIELDS.canRequest.key])}
                onChange={(e) => handleChange(FIELDS.canRequest.key, e.target.checked)}
                name={FIELDS.canRequest.name}
              />
            }
            label={FIELDS.canRequest.name}
          />
          <FormControlLabel
            control={
              <Switch
                color="primary"
                size="small"
                checked={Boolean(user[FIELDS.canCancel.key])}
                onChange={(e) => handleChange(FIELDS.canCancel.key, e.target.checked)}
                name={FIELDS.canCancel.name}
              />
            }
            label={FIELDS.canCancel.name}
          />
        </FormGroup> */}

        <div className="mt-4">
          <Divider />
        </div>
        <div className="flex justify-end pt-3">
          <Button
            size="small"
            color="primary"
            variant="contained"
            disableElevation
            disabled={loading}
            type="submit"
          >
            {loading ? (
              <CircularProgress
                style={{ color: 'white' }}
                size={16}
                className="my-1"
                thickness={10}
              />
            ) : (location.state as any)?.edit ? (
              'Guardar'
            ) : (
              'Registrar'
            )}
          </Button>
        </div>
      </form>
    </div>
  )
}

export default UserForm
